module.exports = __webpack_public_path__ + "static/media/pac.3d5c5b85.png";